import React, { useState } from 'react';
import { useDispatch, batch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { removeSaveLocation } from '../../../api/emailsApi/emails';
import * as MailActions from '../../actions/mail';
import * as RootActions from '../../actions/index';
import './DeselectRecordModal.scss';

export const DeselectRecordModal = ({ recordToDeselect, setRecordToDeselect }) => {
  const emailId = useSelector((state) => state.mail.activeEmail);
  const currentRemovalJobId = useSelector((state) => state.mail.removalJobId);
  const ownerEmail = useSelector((state) => state.mail.ownerEmail);
  const selectedRecordId = recordToDeselect;
  const [removeOption, setRemoveOption] = useState('singleEmail');
  const dispatch = useDispatch();

  const selectOption = (e) => {
    setRemoveOption(e.target.value);
  };

  // Close Modal Function
  const closeModal = () => {
    setRemoveOption('singleEmail');
    setRecordToDeselect();
  };

  // Deselect record
  const deselectRecord = async (e) => {
    e.preventDefault();
    batch(() => {
      dispatch(MailActions.isRemovingSaveLocation(true));
      dispatch(RootActions.changeAlertText('Removing Saved Location...'));
      dispatch(RootActions.isLoading(true));
    });

    closeModal();

    // Backend Api call to delete associated record goes here
    const deleteThread = removeOption === 'entireThread';
    // try/catch
    try {
      const response = await removeSaveLocation(emailId, deleteThread, currentRemovalJobId, selectedRecordId, ownerEmail);
      const jobId = response.removalJobId;
      dispatch(MailActions.setRemovalJobId(jobId));
    } catch (error) {
      console.error(`Error removing save location: ${error}`);
    }
  };

  return (
    <div className={recordToDeselect ? 'deselectModal' : 'deselectModal-disabled'}>
      <div className='deselectModal-formWindow'>
        <div className='deselectModal-formWindow-header'>
          <p><strong>Remove Saved Location</strong></p>
        </div>
        <div className='deselectModal-formWindow-body'>
          <p>
            Removing the saved location from this email will delete all associated documents
            and email records in Litify.
          </p>
          <p>
            Select if you want to remove documents and email records from just this email or
            the entire thread.
          </p>
          <div className='deselectModal-formWindow-body-form'>
            <p><strong>Remove Saved Location</strong></p>

            <div className='deselectModal-formWindow-body-form-formOption'>
              <input type='radio' name='removeOptions' value='singleEmail' id='singleEmail' checked={removeOption === 'singleEmail'} onChange={selectOption}/>
              <label htmlFor='singleEmail'>Remove this email only</label>
            </div>

            <div className='deselectModal-formWindow-body-form-formOption'>
              <input type='radio' name='removeOptions' value='entireThread' id='entireThread' checked={removeOption === 'entireThread'} onChange={selectOption}/>
              <label htmlFor='entireThread'>Remove entire thread</label>
            </div>
          </div>
          <div className='deselectModal-formWindow-body-buttonContainer'>
            <button id='cancel' onClick={closeModal}>Cancel</button>
            <button id='remove' onClick={deselectRecord}>Remove</button>
          </div>
        </div>
      </div>
    </div>
  );
};

DeselectRecordModal.propTypes = {
  recordToDeselect: PropTypes.bool,
  setRecordToDeselect: PropTypes.func,
};
